module.exports = __webpack_public_path__ + "img/list-cross.d7b87901.svg";